import { getMarketId, getBetSlipOdds, getSelectionSide, getMarketTypeId, isMarketQA, getMarketEventID } from "../helpers";
import { BsUtilEmptySelection, BsUtilEmptyMarket } from "../constants";
/**
 * @class
 * @classdesc Parse BFF items to FullBetSlip items
 */
export class Parser {
    /**
     * @method getLegacySelectionData
     * @description Parse selection to FullBetSlip selection
     * @param {Event} event Event, retrieved form BFF
     * @param {Market} market Market, retrieved form BFF
     * @param {Selection} selection Selection, retrieved form BFF
     * @return {BsSelection} Selection in FullBetSlip format
     */
    getLegacySelectionData(event, market, selection) {
        const m = Object.assign(Object.assign({}, BsUtilEmptyMarket), market);
        const s = Object.assign(Object.assign({}, BsUtilEmptySelection), selection);
        const isQA = isMarketQA(m);
        let qaParams = isQA && s.id ? s.id.slice(s.id.indexOf("Q1")).split(/Q[1-2]/).filter(x => x.length) : ["-1", "-1"];
        return {
            masterEventID: parseInt(getMarketEventID(event, m)),
            eventID: parseInt(getMarketId(m)),
            lineID: parseInt(s.metadata.idSBTech),
            odds: parseInt(getBetSlipOdds(s.displayOdds)),
            lineGroupID: s.group,
            lineTypeID: parseInt(s.metadata.type),
            rowTypeID: getSelectionSide(s),
            points: s.points,
            isLive: m.isLive,
            isQA: isMarketQA(m),
            eventTypeId: parseInt(getMarketTypeId(m)),
            leagueId: parseInt(m.leagueId),
            betId: 0,
            preventUpdating: false,
            isFavedTeam: false,
            qaParameter1: parseInt(qaParams[0]),
            qaParameter2: parseInt(qaParams[1])
        };
    }
}
//# sourceMappingURL=parser.js.map